"use client";

import { AnimatePresence, motion } from "motion/react";
import { IconUser } from "@tabler/icons-react";
import { Box, Group, Image, Paper, Text } from "@mantine/core";
import { AVATARS, computeProgress } from "./utils";

export function MobilePreviewBar({ draft }) {
  const avatar = AVATARS.find((a) => a.id === draft.avatarId);
  const progress = computeProgress(draft);

  return (
    <Paper
      hiddenFrom="lg"
      withBorder
      radius="xl"
      p={10}
      shadow="sm"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(12px)",
      }}
    >
      <Group wrap="nowrap" gap="sm">
        {/* Avatar */}
        <Box
          w={44}
          h={44}
          style={{
            flexShrink: 0,
            display: "grid",
            placeItems: "center",
            overflow: "hidden",
            borderRadius: "var(--mantine-radius-md)",
            border: `2px solid ${
              avatar
                ? `var(--mantine-color-${avatar.accent}-5)`
                : "var(--mantine-color-gray-3)"
            }`,
            backgroundColor: "var(--mantine-color-gray-1)",
          }}
        >
          {avatar ? (
            <Image
              src={avatar.src || "/placeholder.svg"}
              alt=""
              w="100%"
              h="100%"
              fit="cover"
            />
          ) : (
            <IconUser size={20} color="var(--mantine-color-gray-5)" />
          )}
        </Box>

        {/* Textes (Nom & Rôle) */}
        <Box style={{ minWidth: 0, flex: 1 }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={draft.name || "x"}
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Text size="sm" fw={600} truncate c="dark">
                {draft.name || "Votre agent"}
              </Text>
            </motion.div>
          </AnimatePresence>
          <Text size="xs" c="dimmed" truncate>
            {draft.role ? `${draft.role} IA` : "En construction…"}
          </Text>
        </Box>

        {/* Barre de progression miniature */}
        <Group gap="xs" wrap="nowrap" style={{ flexShrink: 0 }}>
          <Box
            w={64}
            h={6}
            bg="gray.2"
            style={{ borderRadius: 9999, overflow: "hidden" }}
          >
            <motion.div
              style={{
                height: "100%",
                backgroundColor: "var(--mantine-color-primary-6)",
                borderRadius: 9999,
              }}
              animate={{ width: `${progress}%` }}
            />
          </Box>
          <Text size="xs" fw={600} c="primary">
            {progress}%
          </Text>
        </Group>
      </Group>
    </Paper>
  );
}
